module.exports = __webpack_public_path__ + "img/einsatzabteilung.fd127b15.jpg";